import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { useComparativoMensualProduccion } from "../hooks/useComparativoMensualProduccion";
import { AlcanceCierre } from "./AlcanceCierre";
import { FiltrosCierreProduccion } from "./FiltrosCierreProduccion";
import { IndicacionSiguienteCierre } from "./IndicacionSiguienteCierre";
import { MensajeReporteSinDatos } from "../../../components/MensajeReporteSinDatos";
import { SeccionDiferenciasAcopio } from "./SeccionDiferenciasAcopio";
import { SeccionesComparativo } from "../../../components/SeccionesComparativo";

// Compara las tres formas de medir la chipa que entró a producción (compra,
// tolva y liquidación) contra la producción que se obtuvo en el mismo periodo,
// junto con los dos reportes de los que salen esas cifras. Es también desde
// donde se cierra el periodo, con esas mismas cifras a la vista
export const CierreMensualProduccionForm = ({ regresar }) => {
    const hook = useComparativoMensualProduccion({ regresar });


    return (
        <LoadMask loading={hook.cargando} blur>
            <div className="cierres-mensuales__table-header">
                <FiltrosCierreProduccion hook={hook} />
                <IndicacionSiguienteCierre hook={hook} />
            </div>

            <AlcanceCierre hook={hook} />

            {hook.comparativo ? (
                <SeccionesComparativo
                    comparativo={hook.comparativo}
                    pendientesTraslados={
                        hook.previsualizacion
                            ? hook.previsualizacion.traslados
                            : null
                    }
                >
                    <SeccionDiferenciasAcopio hook={hook} />
                </SeccionesComparativo>
            ) : (
                <MensajeReporteSinDatos mensajeError={hook.mensajeError} />
            )}

            <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
            </div>
        </LoadMask>
    );
};
